import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { shouldBlockFeature } from '../utils/profileUtils';
import { useProfileCompletion } from '../hooks/useProfileCompletion';
import ProfileIncompleteModal from './ProfileIncompleteModal';

const ProtectedFeatureRoute = ({ children, feature }) => {
    const [showModal, setShowModal] = useState(false);
    const [isBlocked, setIsBlocked] = useState(false);
    const [shouldRedirect, setShouldRedirect] = useState(false);
    
    // Use the profile completion hook for real-time data
    const { profileCompletion, loading } = useProfileCompletion();

    useEffect(() => {
        // Check profile completion when it's available
        if (!loading && profileCompletion) {
            console.log(`[ProtectedRoute] Checking feature ${feature}, profile completion:`, profileCompletion);
            
            const blocked = shouldBlockFeature(feature, profileCompletion);
            console.log(`[ProtectedRoute] Feature ${feature} blocked:`, blocked);
            
            setIsBlocked(blocked);
            if (blocked) {
                setShowModal(true);
            }
        } else if (!loading && !profileCompletion) {
            // If no profile data and not loading, assume incomplete
            console.log(`[ProtectedRoute] No profile data for feature ${feature}, blocking access`);
            setIsBlocked(true);
            setShowModal(true);
        }
    }, [feature, profileCompletion, loading]);

    const handleModalHide = () => {
        setShowModal(false);
        // Navigate to dashboard
        setShouldRedirect(true);
    };

    if (shouldRedirect) {
        return <Navigate to="/app/dashboard" replace />;
    }

    if (isBlocked) {
        return (
            <>
                <ProfileIncompleteModal
                    visible={showModal}
                    onHide={handleModalHide}
                    feature={feature}
                />
                {/* Show a blocked state UI */}
                <div className="surface-card p-4 shadow-2 border-round">
                    <div className="text-center p-5">
                        <i className="pi pi-lock text-6xl text-orange-500 mb-3"></i>
                        <h2 className="text-900 font-semibold mb-2">Feature Locked</h2>
                        <p className="text-600 mb-4">
                            Please complete your profile to access this feature.
                        </p>
                        <div className="flex justify-content-center gap-3">
                            <button 
                                className="p-button p-component p-button-outlined"
                                onClick={() => window.location.href = '/app/dashboard'}
                            >
                                <span className="p-button-label">Go to Dashboard</span>
                            </button>
                            <button 
                                className="p-button p-component"
                                onClick={() => window.location.href = '/app/profile/complete'}
                            >
                                <span className="p-button-label">Complete Profile</span>
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    // Feature is not blocked, render children
    return children;
};

export default ProtectedFeatureRoute;